export default function generateID(){
  return (new Date().getTime()).toString(36)
}
